import React, { useEffect, useState } from "react";
import categoryAPI from "../../api/categoryApi";
import { useParams } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import CategoryCard from "../categories/Card";
import ProductCard from "../products/Card";
import { useSiteConfig } from "../../context/SiteConfigContext";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaGlobe,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaMap,
} from "react-icons/fa";
import { MapPin } from "lucide-react";
import CategoriesdetailCard from "./CategoriesdetailCard";

function DetailPage() {
  const { "*": slug } = useParams();
  const [item, setItem] = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  const { config } = useSiteConfig();

  const fetchCategoryDetail = async () => {
    try {
      const res = await categoryAPI.details(slug);

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.category);
        setSubCategories(result?.subcategories);
        setProducts(result?.products);
        setMetaData(result?.category?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing();

      if (res.code === 200) {
        const { items, totalCount } = res.data;

        setItems(items);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrump title={item?.name} />

      <SEO meta={metaData} />

      {subcategories && subcategories.length > 0 && (
        <section className="s-term-user flat-spacing-25">
          <div className="container">
            <div className="row">
              {subcategories.map((subcategory, index) => (
                <div className="col-md-2" key={index}>
                  <CategoryCard item={subcategory} />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {products && products.length > 0 && (
        <div className="   custom-our-categ-sec  flat-spacing-2">
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav ">
              <div className="flat-title-our-product text-start">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8  col-12  custom-det-catg-sec ">


                      {item?.description && (
                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                      )}
                       
                        <h4>Our Products </h4>

                       <div className="row">
                {products.map((product, index) => (
                  <>
                    <div
                      className="col-lg-6 col-sm-6 col-xs-6 mb-2"
                      key={[product._id || index]}
                    >
                      <ProductCard item={product} />
                    </div>
                  </>
                ))}
              </div>

                    </div>

                    <div className="col-lg-4  col-12">
                      <div className="ax-catg-detail-cont-wrapper ">
                        <div className="ax-catg-detail-cont-card p-4">
                          <h3 className="ax-catg-detail-cont-title mb-4">
                            Contact Us
                          </h3>

                          {/* Phone */}
                          <div className="ax-catg-detail-cont-item d-flex mb-4">
                            <FaPhoneAlt className="ax-catg-detail-cont-icon me-3" />
                            <div>
                              <h6 className="ax-catg-detail-cont-heading">
                                Phone Number
                              </h6>
                              <span>
                                <a
                                  className="text-muted text-decoration-none  custom-catg-detl-email"
                                  href={`tel:+91 ${config?.phone}`}
                                >
                                  +91 {config?.phone}
                                </a>
                              </span>
                            </div>
                          </div>

                          {/* Email */}
                          <div className="ax-catg-detail-cont-item d-flex mb-4">
                            <FaEnvelope className="ax-catg-detail-cont-icon me-3" />
                            <div>
                              <h6 className="ax-catg-detail-cont-heading">
                                Email Address
                              </h6>
                              <span>
                                {" "}
                                <a
                                  className="text-muted  custom-catg-detl-email"
                                  href={`mailto: ${config?.email}`}
                                >
                                  {config?.email}
                                </a>
                              </span>
                            </div>
                          </div>

                          <div className="ax-catg-detail-cont-item d-flex mb-4">
                            <MapPin
                              size={22}
                              className="ax-catg-detail-cont-icon me-3"
                            />
                            <div>
                              <h6 className="ax-catg-detail-cont-heading">
                                Email Address
                              </h6>
                              <p className="custom-catg-detl-email">
                                <span>
                                  {[
                                    config?.address?.addressLine,
                                    config?.address?.district,
                                    config?.address?.state,
                                  ]
                                    .filter(Boolean)
                                    .join(", ")}
                                  {config?.address?.pincode
                                    ? ` - ${config?.address.pincode}`
                                    : ""}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="ax-catg-detail-cont-wrapper  mt-5 ">
                        <div className="ax-catg-detail-cont-card-to p-4">
                          <h3 className="ax-catg-detail-cont-title mb-4">
                            Explore Categories
                          </h3>
                          {items && items.length > 0 && (
                            <div className="row   g-3">
                              {items.map((item, index) => (
                                <div className="  col-12" key={index}>
                                  <CategoriesdetailCard item={item} />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                 
                </div>
              </div>
              
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DetailPage;
